import styled from 'styled-components';

export const ChartContainer = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
  height: fit-content;
  width: 100%;
  max-width: none;
`;

export const TotalsContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  justify-content: center;
  flex-wrap: wrap;
`;

export const TotalCard = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  min-width: 160px;
  flex: 1;
  max-width: 200px;
  border: 1px solid #e9ecef;
`;

export const TotalValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #8a1eff;
  margin-bottom: 6px;
  line-height: 1.2;
`;

export const TotalLabel = styled.div`
  font-size: 13px;
  color: #6c757d;
  font-weight: 500;
  line-height: 1.3;
`;

export const SelectorContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 768px) {
    justify-content: center;
    gap: 8px;
  }
`;

export const PeriodSelector = styled.div`
  display: flex;
  gap: 8px;
`;

export const PeriodButton = styled.button<{ active: boolean }>`
  background: ${props => (props.active ? '#8A1EFF' : '#fff')};
  color: ${props => (props.active ? '#fff' : '#8A1EFF')};
  border: 2px solid #8a1eff;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 70px;

  &:hover {
    background: ${props => (props.active ? '#7A0EEF' : '#f8f9fa')};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 12px;
    min-width: 60px;
  }
`;

export const MonthYearSelector = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ChartWrapper = styled.div`
  width: 100%;
  height: 350px;

  @media (max-width: 768px) {
    height: 300px;
  }
`;
